import { createStore } from 'vuex'

export default createStore({
  state: {
    currentStep: 0,
    currentCategory: null,
    currentScores: null,
    fields: [],
    steps: [
      {
        id: 0,
        component: 'Intro'
      },
      {
        id: 1,
        component: 'Directions'
      },
      {
        id: 2,
        component: 'MainTable'
      },
      {
        id: 3,
        component: 'Answer'
      },
      {
        id: 4,
        component: 'Congrats'
      },
    ],
    blocks: [
      {
        categoryID: 'c1',
        categoryName: 'People',
        categoryImage: require('@/assets/images/answer-bg.jpg'),
        items: [
          {
            scores: '100',
            question: 'Which celebrity was born <br> in California?',
            questionVariant1: 'Zendaya',
            questionVariant2: 'Timothée Chalamet',
            questionVariant3: 'Taylor Swift',
            answer: 'A. Zendaya',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '200',
            question: 'Which native American <br> group is indigenous <br> to California?',
            questionVariant1: 'Mohawk',
            questionVariant2: 'Chilula',
            questionVariant3: 'Nez Perce',
            answer: 'B. Chilula',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '300',
            question: 'In 1959, which iconic toy did <br> businesswoman Ruth Handler <br> create in Los Angeles?',
            questionVariant1: 'Hula hoop',
            questionVariant2: 'Nintendo',
            questionVariant3: 'Barbie',
            answer: 'C. Barbie',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '400',
            question: 'Tennis superstars Venus <br> and Serena Williams grew <br> up in what city?',
            questionVariant1: 'Claremont',
            questionVariant2: 'Compton',
            questionVariant3: 'Covina',
            answer: 'B. Compton',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '500',
            question: 'Which California native <br> was the first American <br> woman in space?',
            questionVariant1: 'Sally Ride',
            questionVariant2: 'Eileen Collins',
            questionVariant3: 'Catherine Coleman',
            answer: 'A. Sally Ride',
            isRevealed: false,
            isShowed: false
          }
        ]
      },
      {
        categoryID: 'c2',
        categoryName: 'Places',
        categoryImage: require('@/assets/images/c2-bg.jpg'),
        items: [
          {
            scores: '100',
            question: 'Which of these is a real <br> city in California?',
            questionVariant1: 'San Leon',
            questionVariant2: 'San Rafael',
            questionVariant3: 'San Perlita',
            answer: 'B. San Rafael',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '200',
            question: 'You can find the world’s <br> tallest living tree in which <br> California national park?',
            questionVariant1: 'Yosemite',
            questionVariant2: 'Sequoia',
            questionVariant3: 'Joshua Tree',
            answerTitle: 'You can find the world’s tallest <br> living tree in which California <br> national park?',
            answer: 'B. Sequoia',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '300',
            question: 'Which California landmark <br> is painted a unique color <br> called “International <br> Orange”?',
            questionVariant1: 'Alcatraz',
            questionVariant2: 'Golden Gate Bridge',
            questionVariant3: 'Hollywood Sign',
            answerTitle: 'Which California landmark is painted <br> a unique color called <br> “International  Orange”?',
            answer: 'B. Golden Gate Bridge',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '400',
            question: 'Which California county <br> produces more dairy milk <br> than any other county <br> in the United States?',
            questionVariant1: 'Tulare',
            questionVariant2: 'Humboldt',
            questionVariant3: 'Contra Costa',
            answer: 'A. Tulare',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '500',
            question: 'Fresno, California, <br> is the top producer <br> of what food?',
            questionVariant1: 'Potato chips',
            questionVariant2: 'Candy',
            questionVariant3: 'Raisins',
            answer: 'C. Raisins',
            isRevealed: false,
            isShowed: false
          }
        ]
      },
      {
        categoryID: 'c3',
        categoryName: 'Things',
        categoryImage: require('@/assets/images/c3-bg.jpg'),
        items: [
          {
            scores: '100',
            question: 'Which item of clothing was <br> invented in California?',
            questionVariant1: 'Blue jeans',
            questionVariant2: 'The tuxedo',
            questionVariant3: 'Baseball caps',
            answer: 'A. Blue jeans',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '200',
            question: 'More than 3.5 million of these <br> artifacts have been found <br> at the La Brea Tar Pits.',
            questionVariant1: 'Pottery',
            questionVariant2: 'Fossils',
            questionVariant3: 'Arrowheads',
            answer: 'C. Arrowheads',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '300',
            question: 'Which San Francisco icon <br> is America’s first moving <br> National Historic Landmark?',
            questionVariant1: 'Golden Gate Ferry',
            questionVariant2: 'Cable Cars',
            questionVariant3: 'The Presidio',
            answer: 'B. Cable Cars',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '400',
            question: 'What was Los Angeles’ <br> iconic Hollywood sign <br> originally built to promote?',
            questionVariant1: 'Real estate',
            questionVariant2: 'Filmmaking',
            questionVariant3: 'Yoga',
            answer: 'A. Real estate',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '500',
            question: 'Which chemical element <br> was named for California?',
            questionVariant1: 'Silicon',
            questionVariant2: 'Krypton',
            questionVariant3: 'Californium',
            answer: 'C. Californium',
            isRevealed: false,
            isShowed: false
          }
        ]
      },
      {
        categoryID: 'c4',
        categoryName: 'Mystery',
        categoryImage: require('@/assets/images/c4-bg.jpg'),
        items: [
          {
            scores: '100',
            question: 'California’s state motto,“Eureka,” <br> commemorates what event?',
            questionVariant1: 'The Gold Rush',
            questionVariant2: 'Completion of the <br> Transcontinental Railroad',
            questionVariant3: 'The San Francisco <br> Earthquake',
            answer: 'A. The Gold Rush',
            isRevealed: false,
            isShowed: false,
            class: 'text-start'
          },
          {
            scores: '200',
            question: 'California dairy milk is a <br> top source of which <br> nutrient?',
            questionVariant1: 'Protein',
            questionVariant2: 'Iron',
            questionVariant3: 'Fiber',
            answer: 'A. Protein',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '300',
            question: 'What place described in a <br> 16th-century Spanish novel <br> did California get <br> its name from?',
            questionVariant1: 'Heaven',
            questionVariant2: 'A mythical paradise',
            questionVariant3: 'An alien planet',
            answerTitle: 'What place described in a <br> 16th-century Spanish novel did <br> California get its name from?',
            answer: 'B. A mythical paradise',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '400',
            question: 'What is the official sport <br> of California?',
            questionVariant1: 'Skiing',
            questionVariant2: 'Skateboarding',
            questionVariant3: 'Surfing',
            answer: 'C. Surfing',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '500',
            question: 'What species of bear <br> can be found on <br> California’s state flag?',
            questionVariant1: 'Grizzly',
            questionVariant2: 'Panda',
            questionVariant3: 'Andean',
            answer: 'A. Grizzly',
            isRevealed: false,
            isShowed: false
          }
        ]
      },
    ],
    directions: {
        items: [
          'Check out the four categories on the game board.',
          'Click a category and value — for example, <i>Places </i> for 200 — to reveal the <b>question and answer options</b>',
          'State or write down your response and then click the  <b>Reveal Answer</b>  button. <ul><li>If you are correct, your team gets to choose again. </li><li>If not, the other team chooses next.</li></ul>',
          'Tally your points as you play to determine the winner.'
        ]
      },
    isAnswerActive: false,
    soundEnabled: false,
    revealedQuestions: 0,
    curAnswerObj: {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    },
    audio: [
      {
        id: 'theme_music',
        src: require('@/assets/media/theme_music.mp3'),
        playing: false,
        loop: true
      },
      {
        id: 'question_reveal',
        src: require('@/assets/media/question_reveal.mp3'),
        playing: false,
        loop: false
      },
      {
        id: 'answer_reveal',
        src: require('@/assets/media/answer_reveal.mp3'),
        playing: false,
        loop: false
      },
      {
        id: 'congrats',
        src: require('@/assets/media/cheers-with-fadeout.mp3'),
        playing: false,
        loop: false
      },
    ],
  },

  getters: {
    getBlocks: s => s.blocks,
    getAnswers: s => {
      let answers = []
      Array.from(s.blocks).forEach(block => {
        answers = [...answers, ...block.items]
      })
      return answers
    },
    getBlocksLength: s => s.blocks[0].items.length,
    getDirectionsItems: s => s.directions.items,
    getCurrentStepIndex: s => s.currentStep,
    getCurrentStep: s => s.steps.find(step => step.id === s.currentStep),
    getCurrentCategory: s => s.blocks.find(block => block.categoryID === s.currentCategory),
    getCurrentAnswer: (s, getters) => getters.getCurrentCategory.items.find(item => item.scores === s.currentScores),
    getSound: s => id => s.audio.find((sound) => sound.id === id),
    getSounds: s => s.audio,
    getAnswerState: s => s.isAnswerActive,
    getAnswerPos: s => s.curAnswerObj,
    getSoundState: s => s.soundEnabled,
    getRevealedQuestions: s => s.revealedQuestions
  },
  mutations: {
    nextStep: (s) => {
      const { currentStep } = s;
      if (currentStep < s.steps.length - 1) {
        s.currentStep = currentStep + 1;
      }
    },
    goToStep: (s, num) => {
      s.currentStep = num;
    },
    goToAnswer: (s, {categoryID, scores}) => {
      s.isAnswerActive = true;
      s.currentCategory = categoryID;
      s.currentScores = scores;
    },
    play: (s, id) => {
      s.audio.find((a) => a.id === id).playing = true;
    },
    stop: (s, id) => {
      s.audio.find((a) => a.id === id).playing = false;
    },
    hideAnswer: s => s.isAnswerActive = false,
    updateAnswerPos: (s , obj) => {
      s.curAnswerObj.left = obj.left;
      s.curAnswerObj.top = obj.top;
      s.curAnswerObj.width = obj.width;
      s.curAnswerObj.height = obj.height;
    },
    switchSoundState: s => s.soundEnabled = !s.soundEnabled,
    updateRevealedQuestions: s => s.revealedQuestions++
  },
  actions: {
  },
  modules: {
  }
})
